<template>
  <div class="pt-4 sm:pt-0">
    <div class="flex flex-row justify-between items-center">
      <el-breadcrumb v-if="showBreadcrumb" separator="/">
        <el-breadcrumb-item :to="{ name: 'DASHBOARD' }">{{
          $t('DASHBOARD')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="router != undefined"
          :to="{ name: router.name }"
        >
          {{ $t(router.name) }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t($route.name) }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div
      class="
        bg-white
        p-4
        rounded-tl-2xl rounded-tr-md rounded-br-2xl rounded-bl-md
        shadow-md
        border-r-4
        relative
        mt-4
      "
      :class="childClass"
    >
      <titleHolder v-if="title != undefined" :title="$t(title)" />
      <router-link
        v-if="type == 'list'"
        to="./add"
        class="absolute top-4"
        :class="{
          'left-4': $i18n.locale == 'fa',
          'right-4': $i18n.locale != 'fa',
        }"
      >
        <el-button type="success" round>
          <i class="el-icon-plus font-medium ml-1"></i>
          {{ $t('NEW_REGISTERATION') }}
        </el-button>
      </router-link>
      <slot></slot>
      <Pagination
        v-if="pagination != null"
        :pagination="pagination"
        @tableData="$emit('tableData', $event)"
        @loading="$emit('loading', $event)"
      />
    </div>
  </div>
</template>
<script>
import titleHolder from '@/components/elements/title.vue'
import { mapGetters } from 'vuex'
import Pagination from './pagination'

export default {
  props: {
    title: {
      type: String,
      default: undefined,
    },
    childClass: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: '',
    },
    router: {
      type: Object,
      default: undefined,
    },
    showBreadcrumb: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Object,
      default: null,
      required: false,
    },
  },
  components: {
    titleHolder,
    Pagination,
  },
  computed: {
    ...mapGetters(['locale']),
  },
  methods: {},
}
</script>
<style scoped>
.bg-white {
  border-color: #ff5604;
}
</style>
